<template>
  <div class="dialog-mask" role="presentation">
    <div
      class="dialog-content"
      role="dialog"
      aria-modal="true"
      :aria-labelledby="titleId"
      :aria-describedby="descriptionId"
    >
      <header class="dialog-header">
        <h2 :id="titleId" class="dialog-title">{{ $t("desktopBetaPage.windowsInstallGuide.title") }}</h2>
      </header>
      <p :id="descriptionId" class="dialog-description">
        {{ $t("desktopBetaPage.windowsInstallGuide.description") }}
      </p>
      <div class="dialog-image-wrap">
        <img
          class="dialog-image"
          src="@/assets/img/desktop-beta/windows-install.webp"
          :alt="String($t('desktopBetaPage.windowsInstallGuide.imageAlt'))"
        />
      </div>
      <div class="dialog-actions">
        <button-default class="confirm-button" @click="close">
          {{ $t("desktopBetaPage.windowsInstallGuide.confirm") }}
        </button-default>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import ButtonDefault from "@/components/atoms/ButtonDefault.vue";

export default Vue.extend({
  name: "DesktopBetaWindowsInstallDialog",
  components: { ButtonDefault },
  data() {
    return {
      titleId: "desktop-beta-windows-install-title",
      descriptionId: "desktop-beta-windows-install-description",
    };
  },
  methods: {
    close() {
      this.$emit("close");
    },
  },
});
</script>

<style lang="scss" scoped>
.dialog-mask {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  z-index: 9000;
  align-items: center;
  justify-content: center;
  padding: 16px;
  background-color: var(--color-overlay);
}

.dialog-content {
  position: relative;
  box-sizing: border-box;
  width: min(760px, calc(100vw - 32px));
  max-height: min(90vh, 100%);
  padding: 20px 20px 24px;
  border-radius: var(--radius-sm);
  background-color: var(--color-background-normal);
  color: var(--color-text-normal);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.dialog-header {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 24px;
}

.dialog-title {
  margin: 0;
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-bold);
  line-height: 1.5;
  text-align: center;
}

.dialog-description {
  margin: 0 0 16px;
  padding: 0 24px;
  font-size: var(--font-size-md);
  line-height: 1.7;
  text-align: left;
  white-space: pre-line;
}

.dialog-image-wrap {
  flex: 1;
  min-height: 0;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  display: flex;
  justify-content: center;
}

.dialog-image {
  display: block;
  width: 100%;
  height: auto;
  border-radius: var(--radius-sm);
}

.dialog-actions {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.confirm-button {
  margin: 0;
  width: auto;
  min-width: 200px;
  white-space: nowrap;
  border-radius: var(--radius-rounded);
  background-color: var(--color-primary);
  border-color: var(--color-primary);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-bold);
  color: var(--color-text-on-fixed-bg);
  cursor: pointer;
}
</style>
